import { index, real, sqliteTable, text, uniqueIndex } from "drizzle-orm/sqlite-core";

export const taxFilings = sqliteTable("accounting_tax_filings", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  formType: text("form_type", {
    enum: ["pp30", "pnd3", "pnd53", "pp36"],
  }).notNull(),
  periodMonth: text("period_month").notNull(),
  periodFrom: text("period_from").notNull(),
  periodTo: text("period_to").notNull(),
  status: text("status", {
    enum: ["draft", "reviewing", "approved", "filed", "paid", "locked", "reopened", "corrected"],
  }).notNull().default("draft"),
  snapshotVersion: text("snapshot_version").notNull().default("1"),
  snapshotJson: text("snapshot_json"),
  sourceIdsJson: text("source_ids_json"),
  totalBaseAmount: real("total_base_amount").notNull().default(0),
  totalTaxAmount: real("total_tax_amount").notNull().default(0),
  payableAmount: real("payable_amount").notNull().default(0),
  exportReference: text("export_reference"),
  filingReference: text("filing_reference"),
  filingChannel: text("filing_channel"),
  filedAt: text("filed_at"),
  filedBy: text("filed_by"),
  paymentReference: text("payment_reference"),
  paymentDate: text("payment_date"),
  paymentAmount: real("payment_amount"),
  paidAt: text("paid_at"),
  paidBy: text("paid_by"),
  periodLockId: text("period_lock_id"),
  lockedAt: text("locked_at"),
  lockedBy: text("locked_by"),
  approvalRequestId: text("approval_request_id"),
  reopenReason: text("reopen_reason"),
  correctionReason: text("correction_reason"),
  reopenedAt: text("reopened_at"),
  reopenedBy: text("reopened_by"),
  reviewedAt: text("reviewed_at"),
  reviewedBy: text("reviewed_by"),
  approvedAt: text("approved_at"),
  approvedBy: text("approved_by"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  companyFormPeriodBranchIdx: uniqueIndex("tf_company_form_period_branch_idx").on(
    table.companyId,
    table.formType,
    table.periodMonth,
    table.branchId,
  ),
  companyStatusIdx: index("tf_company_status_idx").on(table.companyId, table.status, table.periodMonth),
  companyPeriodIdx: index("tf_company_period_idx").on(table.companyId, table.periodMonth),
  periodLockIdx: index("tf_period_lock_idx").on(table.periodLockId),
}));

export type TaxFiling = typeof taxFilings.$inferSelect;
export type NewTaxFiling = typeof taxFilings.$inferInsert;
